import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from "react-select";
//import { Select } from 'rmwc/Select';

class AdminEditCompetencyDisplay extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
        	displayMsg: '',
            'selectedcompetencyList': [],
    		data:{
    			'competencyId' : '',
    			'competencyName' : '',
                'competencyList' : [],
    		}
    	};
 	}

    handleSave = (e) => {
        e.preventDefault();
        let parent_details = []
        let data = {
            'parent_details' :this.state.selectedcompetencyList,
            'mc_competency_id' : this.state.data.competencyId,
            'active' : 1
        }
        api.adminCompetencySequenceUpdate(this.props.user.accessToken, data)
            .then((result) => {
                if (result.status === 'success'){
                    this.setState({displayMsg: 'The sequence has been updated.'})
                }
                else if (result.status === 'error'){
                    this.setState({displayMsg: 'There seems to be an error. Please try again.'})
                }
            })
    }

    handleParentCompetency = (option) => {
        this.setState(state => {
            return {
               selectedcompetencyList : option
            };
        });
    }

 	componentDidMount() {
 		let data = Object.assign({}, this.state.data)
        let selectedcompetencyList = Object.assign({}, this.state.selectedcompetencyList)
 		data.competencyName = this.props.competencyName
 		data.competencyId = this.props.competencyId
 		this.setState({data: data})

        return api.adminDropDownCompetencyDisplay(this.props.user.accessToken, this.props.roadmapId, this.props.competencyId)
        .then((result) => {
          data.competencyList = result.data
          this.setState({data: data})
          return api.adminSelectedSequenceDisplay(this.props.user.accessToken, this.state.data.competencyId)
            .then((result) => {
                selectedcompetencyList = result.data
                this.setState({selectedcompetencyList: selectedcompetencyList})
            })
        })
 	}

 	render() {
 		let competencyToShow
 		competencyToShow = (
            <Grid>
        	   <GridCell span="12" style={{background: '#efefefef'}}>
            	   <Typography use="subtitle1">{this.props.competencyName}</Typography>
                </GridCell>
                <GridCell span="10">
                    <Reactsel
                        name="parentCompetency"
                        onChange={this.handleParentCompetency}
                        value={this.state.selectedcompetencyList}
                        options={this.state.data.competencyList}
                        placeholder="--Select Parent Competency--"
                        isMulti>
                    </Reactsel>
                </GridCell>
                <GridCell span="2">
                    <Button raised style={{ width: '80%' }} onClick = {this.handleSave}>Save</Button>
                </GridCell>  
                <GridCell span = "12">
                    <StatusMessage error_msg = {this.state.displayMsg} />
                </GridCell>
            </Grid>
 		)
 		return (
 			<div >
 			    {competencyToShow}
 			</div>
 		)
 	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminEditCompetencyDisplay);


// WEBPACK FOOTER //
// ./src/views/admin/AdminEditCompetencyDisplay.jsx